<div class="container plp-list-container">
    <ng-container
        *ngIf="contentType; else containerScroll"
        [ngSwitch]="contentType"
    >
        <ng-template [ngSwitchCase]="productType.AudioBook">
            <ng-container *ngTemplateOutlet="containerScroll"></ng-container>
        </ng-template>
        <ng-template [ngSwitchCase]="productType.Capsule">
            <ng-container *ngTemplateOutlet="containerScroll"></ng-container>
        </ng-template>
        <ng-template [ngSwitchCase]="productType.AudioSeries">
            <ng-container *ngTemplateOutlet="containerWithoutScroll"></ng-container>
        </ng-template>
        <ng-template [ngSwitchCase]="productType.Podcast">
            <ng-container *ngTemplateOutlet="containerWithoutScroll"></ng-container>
        </ng-template>
    </ng-container>
    <ng-container *ngTemplateOutlet="Overlay"></ng-container>
    <ng-container *ngTemplateOutlet="sortScrollbar"></ng-container>
</div>
<ng-template #containerScroll>
    <div id="containerScroll">
        <navaar-container-scroll
            class="list-categories"
            [showHeader]="true"
            [title]="title"
            [show]="true"
            [isPlayAnimation]="false"
            [isFixedContainer]="true"
        >
            <span
                slot="slotButton"
                class="icon-sort-button"
                (click)="showSortList()"
            >
                <navaar-sort-icon></navaar-sort-icon>
            </span>
            <navaar-plp-list-item
                (go-to)="goToPage($event)"
                [disable-when-fetch-data]="isLoading"
                [isEnd]="isEnd"
                [items]="items"
                [more-icon]="false"
            ></navaar-plp-list-item>
        </navaar-container-scroll>
    </div>
</ng-template>
<ng-template #containerWithoutScroll>
    <div id="containerWithoutScroll">
        <navaar-header
            [title]="title"
            [color]="'#000000'"
        >
            <span
                (click)="showSortList()"
                slot=custom-icon
                class="icon-sort-button"
            >
                <navaar-sort-icon></navaar-sort-icon>
            </span>
        </navaar-header>
        <div
            id="genresInfo"
            *ngIf="genresInfo; else empty"
        >
            <div class="wrapper-item">
                <div class="item-img small-item-img">
                    <img
                        [lazySrc]="genresInfo?.imageUrl + '?w=250&h=250&mode=stretch'"
                        lazySrcVisible="visible"
                        loading="lazy"
                        src="assets/img/placeholder.png"
                    >
                </div>
                <div class="item-text">
                    <span
                        class="item-name truncate-text"
                        [textContent]="genresInfo?.description"
                    ></span>
                    <div class="audioBooksCount">
                        <span [textContent]="genresInfo?.audioBooksCount"></span>
                        <span [textContent]="'قسمت'"></span>
                    </div>
                    <div class="wrapper-description">
                        <!-- <p [class.more-text]="moreTextDesc"> -->
                        <p [class.more-text]="true">
                            {{genresInfo?.abstract}}
                            <!-- *ngIf="genresInfo?.abstract?.length > 170" -->
                            <span
                                class="more-text-style"
                                (click)="moreText()"
                                *ngIf="false"
                            >
                                ادامه مطلب...
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <navaar-plp-list-item
            (go-to)="goToPage($event)"
            [disable-when-fetch-data]="isLoading"
            [isEnd]="isEnd"
            [items]="items"
            [more-icon]="false"
        ></navaar-plp-list-item>
    </div>
</ng-template>
<ng-template #Overlay>
    <div
        [@overlayAnimation]="'visible'"
        (@overlayAnimation.start)="onOVerlayAnimationStart($event)"
        *ngIf="visible"
        class="overlay"
        (click)="close()"
    ></div>
</ng-template>
<ng-template #sortScrollbar>
    <div
        *ngIf="visible"
        [@slidePopup]="AnimationSortListScrollbar"
        (@slidePopup.done)="onSortlistScrollbar($event)"
        (swipedown)="swipe($event.type)"
        id="wrapper-sort"
    >
        <div
            class="wrapper-scrollbar-header"
            [textContent]="sortList.title"
        ></div>
        <div class="wrapper-Scrollbar-body">
            <ul>
                <li
                    class="Scrollbar-items"
                    *ngFor="let item of sortList.items; let i = index"
                    (click)="[sortGenre(item.type), setActive(i)]"
                    [ngClass]="{
                                  activeSortButton: isActive[i],
                                  deactiveSortButton: !isActive[i]
                                }"
                >
                    <div class="title-Scrollbar-items">
                        <span
                            class="item"
                            [textContent]="item.title"
                        ></span>
                    </div>
                    <ng-container *ngIf="isActive[i]">
                        <span class="icon-line-green">
                            <navaar-done-icon></navaar-done-icon>
                        </span>
                    </ng-container>
                </li>
            </ul>
        </div>
    </div>
</ng-template>
<ng-template #empty>
    <div id="genresInfo">
        <div class="wrapper-item">
            <div class="item-img small-item-img">
                <img src="assets/img/placeholder.png">
            </div>
            <div class="item-text"></div>
        </div>
    </div>
</ng-template>
